import { useQuery } from '@tanstack/react-query';

import { CommonModel } from '@telialt/models/src/CommonModel';
import { axiosForHybris } from '@telialt/utils/src/axios/axiosForHybris';
import { withParams } from '@telialt/utils/src/helpers';
import { useHybrisSegment } from '@telialt/utils/src/segment';

import { API } from '../constants';

const apiGetHybrisConfiguration = async (segment: CommonModel.Segment, configProperty: string) =>
    await axiosForHybris.get<string>(withParams(API.HYBRIS_CONFIGURATION, { segment, configProperty }));

export const useHybrisConfiguration = (configProperty: string, enabled = true) => {
    const segment = useHybrisSegment();

    return useQuery({
        queryKey: ['HYBRIS_CONFIGURATION', configProperty],
        queryFn: async () => {
            const { data } = await apiGetHybrisConfiguration(segment, configProperty);

            return data;
        },
        enabled,
    });
};
